import { connect } from 'react-redux';

import { RootState } from 'state/reducers';
import { notificationsActions, selectNotifications } from 'state/notifications';

import Notifications from './Notifications';

const { REMOVE_NOTIFICATION } = notificationsActions;

const mapStateToProps = (state: RootState) => ({
  notifications: selectNotifications(state),
});

const mapDispatchToProps = {
  removeNotification: REMOVE_NOTIFICATION,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
